import { TMCTableModule } from '@sdbn/appclient';
import { DetachTruckAndTrailerComponent } from './component/detach-truck-and-trailer/detach-truck-and-trailer.component';
import { AttachTruckComponent } from './component/attach-truck/attach-truck.component';
import { AttachTrailerComponent } from './component/attach-trailer/attach-trailer.component';
import { DetachTrailerComponent } from './component/detach-trailer/detach-trailer.component';
import { DetachTruckComponent } from './component/detach-truck/detach-truck.component';
import { SelectActionComponent } from './component/select-action/select-action.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportAttachDetachDialogComponent } from './component/transport-attach-detach-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { SelectTrailerSwapTargetComponent } from './component/select-trailer-swap-target/select-trailer-swap-target.component';
import { TrailerSwapSourceDetailsComponent } from './component/trailer-swap-source-details/trailer-swap-source-details.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { StructureSelectionModule } from 'src/tmc-yard/common/structure-selection/structure-selection.module';
import { DetachTrailerSemiTrailerTruckComponent } from './component/detach-trailer-semi-trailer-truck/detach-trailer-semi-trailer-truck.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    StructureSelectionModule
  ],
  declarations: [
    TransportAttachDetachDialogComponent,
    SelectActionComponent,
    DetachTruckComponent,
    DetachTruckAndTrailerComponent,
    DetachTrailerComponent,
    DetachTrailerSemiTrailerTruckComponent,
    AttachTruckComponent,
    AttachTrailerComponent,
    SelectTrailerSwapTargetComponent,
    TrailerSwapSourceDetailsComponent
  ]
})
export class AttachDetachModule { }
